import { CheckIcon, PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface BookingFormEditControlsProps {
  isEditing: boolean;
  hasChanges: boolean;
  onEditModeChange: (editing: boolean) => void;
  onSave: () => void;
  onCancel: () => void;
  onRestore?: () => void;
  canEdit: boolean;
}

const BookingFormEditControls: React.FC<BookingFormEditControlsProps> = ({
  isEditing,
  hasChanges,
  onEditModeChange,
  onSave,
  onCancel,
  onRestore,
  canEdit,
}) => {
  return (
    <div className='flex justify-end gap-6 items-center '>
      {/* Modified indicator */}
      {hasChanges && !isEditing && onRestore && (
        <div className='flex items-center gap-2 text-xs italic text-amber-700'>
          <span>
            Booking data has been modified. Changes are temporary and will be
            lost on page reload.
          </span>
          <button
            onClick={onRestore}
            className='text-blue-600 hover:text-blue-800 underline'
          >
            Restore original
          </button>
        </div>
      )}
      <div className={hasChanges && !isEditing ? '' : 'ml-auto'}>
        {canEdit && !isEditing && (
          <button
            onClick={() => onEditModeChange(true)}
            className='p-2 text-gray-600 hover:text-blue-600 flex items-center gap-1 text-sm'
            title='Edit'
          >
            <PencilIcon className='w-4 h-4' />
            Edit
          </button>
        )}
      </div>
      {isEditing && (
        <div className='flex gap-2'>
          <button
            onClick={onSave}
            className='text-sm px-3 py-1.5 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1'
          >
            <CheckIcon className='w-4 h-4' />
            Save
          </button>
          <button
            onClick={onCancel}
            className='text-sm px-3 py-1.5 bg-gray-500 text-white rounded hover:bg-gray-600 flex items-center gap-1'
          >
            <XMarkIcon className='w-4 h-4' />
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default BookingFormEditControls;
